import { Link, Outlet } from "react-router-dom";
import { CalendarCheck, Phone } from "lucide-react";
import { CONTACT } from "@/data/site";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const Layout = () => (
  <div className="grain min-h-screen bg-brand-sand text-brand-navy">
    <Header />
    <main className="pb-20 lg:pb-0">
      <Outlet />
    </main>
    <Footer />
    <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-white/10 bg-brand-navy text-white lg:hidden" data-testid="mobile-action-bar">
      <a href={CONTACT.phoneHref} data-testid="mobile-action-call" className="flex items-center justify-center gap-2 py-4 text-sm font-extrabold">
        <Phone className="h-4 w-4 text-brand-copper" /> Call Office
      </a>
      <Link to="/contact" data-testid="mobile-action-schedule" className="flex items-center justify-center gap-2 bg-brand-copper py-4 text-sm font-extrabold text-brand-navy">
        <CalendarCheck className="h-4 w-4" /> Schedule
      </Link>
    </div>
  </div>
);
